import { Component, EventEmitter, input, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';
import { TableData, TableOverlayLine } from '../../../../../table-overlay/table-overlay';
import { Dimension2d, WordRect } from '@ps-gui/claims-terminal-shared';

@Component({
  selector: 'ct-extraction-table-overlay-move-intersection',
  imports: [NgClass],
  templateUrl: './table-overlay-move-intersection.component.html',
})
export class TableOverlayMoveIntersectionComponent {
  @Input({ required: true }) tableData!: TableData;
  @Input({ required: true }) tableRect!: WordRect;
  readonly dimension = input.required<Dimension2d>();

  @Output() setArePreviewLinesEnabled = new EventEmitter<boolean>();
  @Output() mouseDown = new EventEmitter<{
    horizontalLine: TableOverlayLine;
    horizontalIndex: number;
    verticalLine: TableOverlayLine;
    verticalIndex: number;
  }>();
}
